module.exports = __webpack_public_path__ + "static/media/icon-particulates-dark.5ae78d82.svg";